import debounce from 'lodash.debounce'
import React from 'react'
import { useSelector } from 'react-redux'
import {
  FormLabel,
  FormDashboardInput as FormInput,
  FormDashboardInputPassword as FormPassword,
  FormRow,
} from '../../../components'
import { formUpdater } from '../../../utils'

const FormAccount = ({ onChange }) => {
  const translation = useSelector(state => state.translation.data)
  const language = useSelector(state => state.system.language)
  const [form, setForm] = React.useState({})

  const updateForm = debounce((e) => formUpdater(e, form, setForm), 250)

  React.useEffect(() => {
    if(typeof onChange === 'function'){
      onChange(form)
    }
    //eslint-disable-next-line
  }, [form])

  return (
    <>
      <h2 className="text-lg mb-5 lg:mb-8 font-primary font-bold">
        {translation.ACCOUNT.information[language.name]}
      </h2>

      <FormRow>
        <FormLabel>
          {translation.AUTH.email[language.name]}
        </FormLabel>
        <FormInput
          name="email"
          className="w-full"
          placeholder={translation.AUTH.email_enter[language.name]}
          type="email"
          autoComplete="username"
          onChange={(e) => {e.persist(); updateForm(e)}}
          required
        />
      </FormRow>

      <FormRow>
        <FormLabel>
          {translation.AUTH.password[language.name]}
        </FormLabel>
        <FormPassword
          name="password"
          className="w-full"
          placeholder={translation.AUTH.password_enter[language.name]}
          autoComplete="new-password"
          onChange={(e) => {e.persist(); updateForm(e)}}
          required
        />
      </FormRow>
    </>
  )
}

export { FormAccount }
